import { render } from "./photos-page.vue?vue&type=template&id=77379a39&class=bg-%5B%23fafbfb%5D"
import script from "./photos-page.vue?vue&type=script&lang=js"
export * from "./photos-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__